'use strict';

module.exports = {
    general: require('./generalMatcher'),
    msem: require('./msemMatcher')
};



// WEBPACK FOOTER //
// ./packages/mf-matcher/src/index.js